"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Content = exports.tabStyle = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _typography = require("../../typography");

var _IconContainer = _interopRequireDefault(require("../../IconContainer"));

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var tabStyle = (0, _styledComponents.css)(["&&{display:inline-block;color:", ";text-decoration:none;font-weight:", ";&:hover,&:focus,&:active{text-decoration:none;color:", ";}font-size:1rem;line-height:1.5rem;padding:16px 0;margin:0 16px 0 0;&:last-child{margin-right:0;}@media ", "{font-size:0.875rem;line-height:1.25rem;padding:8px;}}&&[aria-current='true']{pointer-events:none;color:", ";border-bottom:4px solid ", ";padding:16px 0 14px;@media ", "{padding:8px;}}&&[aria-disabled='true']{pointer-events:none;color:", ";}"], (0, _helpers.color)('dark-1'), (0, _helpers.fontWeight)('bold'), (0, _helpers.color)('accent-3'), (0, _helpers.breakpoint)('maxMobile'), (0, _helpers.color)('accent-3'), (0, _helpers.color)('accent-3'), (0, _helpers.breakpoint)('maxMobile'), (0, _helpers.color)('statusDisabled'));
exports.tabStyle = tabStyle;

var Content = _styledComponents.default.div.withConfig({
  displayName: "Content",
  componentId: "k9w3p1-0"
})(["display:flex;align-items:center;pointer-events:none;font-weight:", ";"], (0, _helpers.fontWeight)('bold'));

exports.Content = Content;

var ActionBarTab = function ActionBarTab(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$link = _ref.link,
      Link = _ref$link === void 0 ? _typography.Link : _ref$link,
      to = _ref.to,
      Icon = _ref.icon,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["children", "className", "link", "to", "icon", "onClick"]);

  var onClickWithBlur = function onClickWithBlur(event) {
    event && event.currentTarget && event.currentTarget.blur();
    onClick && onClick(event);
  };

  return React.createElement(Link, _extends({
    to: to,
    className: className,
    onClick: onClickWithBlur
  }, props), React.createElement(Content, null, Icon && React.createElement(_IconContainer.default, null, React.createElement(Icon, null)), children));
};

var StyledActionBarTab = (0, _styledComponents.default)(ActionBarTab).withConfig({
  displayName: "StyledActionBarTab",
  componentId: "k9w3p1-1"
})(["", ""], tabStyle);
var _default = StyledActionBarTab;
exports.default = _default;